import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DirectoryBase from './DirectoryBase';
import { fetchOpportunitiesThunk, deleteOpportunityThunk, selectOpportunities, selectOpportunityLoading, selectOpportunityTotal, selectLastUpdated, selectOpportunityTags, selectDropdownOptions, } from '../../redux/opportunitySlice';
import UploadDirectoryDrawer from './components/UploadDirectoryDrawer';
import AddNewCreatorDrawer from './components/AddNewCreatorDrawer';
import exportCreatorDirectory from './exportCreatorDirectory';
import { getCreatorDirectoryRenderers } from './components/DirectoryCells';
const CONFIG = {
    MODULE_KEY: 'creator_directory',
    ITEMS_PER_PAGE: 20,
    ICONS: {
        category: '/assets/widgetadd.svg',
        tag: '/assets/tag.svg',
        type: '/assets/bill.svg',
    },
};
const TYPE_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'Paid', label: 'Paid' },
    { value: 'Non-Paid', label: 'Non-Paid' },
];
const COLUMNS = [
    { id: 'category', label: 'Category', minWidth: 130, sortable: true, draggable: false },
    { id: 'type', label: 'Type', minWidth: 100, sortable: true },
    { id: 'creator_name', label: 'Creator Name', minWidth: 150, sortable: true },
    { id: 'creator_handle', label: 'Creator Handle', minWidth: 160, sortable: true },
    { id: 'stats', label: 'Stats', minWidth: 100, sortable: true },
    { id: 'contact_name', label: 'Contact Name', minWidth: 150, sortable: true },
    { id: 'tags', label: 'Tags', minWidth: 180, sortable: true },
    { id: 'primary_lead_name', label: 'Primary Lead', minWidth: 150, sortable: true },
    { id: 'date_added', label: 'Date Added', minWidth: 130, sortable: true },
    { id: 'action', label: 'Action', minWidth: 120, sortable: false, draggable: false },
];
const CreateDirectory = () => {
    const dispatch = useDispatch();
    const dropdownOptions = useSelector(selectDropdownOptions);
    const tags = useSelector(selectOpportunityTags);
    const renderCell = useCallback((row, column, onEdit, onSuccess) => {
        const renderers = getCreatorDirectoryRenderers(row, onEdit, onSuccess, dispatch);
        const wrap = (node) => (_jsx("div", { className: "all-Font-Sizes", style: { textTransform: 'capitalize', color: '#344054', fontSize: '13px' }, children: node }));
        return renderers[column.id]?.() ?? wrap(row[column.id] || '-');
    }, [dispatch]);
    const filtersConfig = useMemo(() => [
        {
            key: 'category',
            icon: CONFIG.ICONS.category,
            label: 'Category',
            options: [{ value: 'all', label: 'All' }, ...(dropdownOptions?.map((c) => ({ value: c.value, label: c.label })) || [])]
        },
        {
            key: 'tags',
            icon: CONFIG.ICONS.tag,
            label: 'Tags',
            options: [{ value: 'all', label: 'All' }, ...(tags?.map((t) => ({ value: t, label: t })) || [])]
        },
        {
            key: 'type',
            icon: CONFIG.ICONS.type,
            label: 'Type',
            options: TYPE_OPTIONS
        },
    ], [dropdownOptions, tags]);
    return (_jsx(DirectoryBase, { moduleKey: CONFIG.MODULE_KEY, pageTitle: "Creator Directory", addNewButtonLabel: "Add New Creator", uploadButtonLabel: "Upload Directory", fetchThunk: fetchOpportunitiesThunk, deleteThunk: deleteOpportunityThunk, exportFn: exportCreatorDirectory, renderCell: renderCell, columns: COLUMNS, filtersConfig: filtersConfig, AddNewDrawer: AddNewCreatorDrawer, UploadDrawer: UploadDirectoryDrawer, selectors: useMemo(() => ({
            items: selectOpportunities,
            loading: selectOpportunityLoading,
            total: selectOpportunityTotal,
            lastUpdated: selectLastUpdated,
            tags: selectOpportunityTags,
        }), []) }));
};
export default CreateDirectory;
